// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rampardos: PokeData = {
  "id": 409,
  "name": "rampardos",
  "height": 16,
  "weight": 1025,
  "base_experience": 173,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "swords-dance",
    "slam",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "leer",
    "bite",
    "screech",
    "focus-energy",
    "rock-slide",
    "scary-face",
    "pursuit",
    "crunch",
    "ancient-power",
    "rock-smash",
    "endeavor",
    "assurance",
    "rock-polish",
    "zen-headbutt",
    "iron-head",
    "head-smash",
    "chip-away"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "leer",
    "bite",
    "rock-slide",
    "scary-face",
    "pursuit",
    "crunch",
    "ancient-power",
    "rock-smash",
    "zen-headbutt",
    "stone-crush",
    "rock-throw"
  ],
  "evolution_chain": {
    "id": 211,
    "item": null,
    "species": [
      {
        "name": "cranidos",
        "order": 436,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rampardos",
        "order": 437,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 408,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 78,
    "ability_power": 221
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
